// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/ComingSoon.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiGrid-root.mainContainerStudio {
    margin-top: 10px;
    overflow-y: auto;
    height: calc(100vh - 9rem);
    align-items: flex-start;
    padding: 0px 20px;
    justify-content: center;
}

/* UploadImage page css */
.uploadContainer {
    background-color: #292B49;
    
    overflow: hidden;
}


.uploadTextContainer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

}

.uploadAddIcon {
    cursor: pointer;
}

.tabsContainer {
    flex-grow: 1;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.tabs {
    border-bottom: 2px solid #565A78;
}

.tabs .MuiTabs-indicator {
    border: 1.5px solid #fff;
}

.tabs .MuiTabs-flexContainer {
    min-height: 60px;
}

.MuiButtonBase-root.tab {
    color: #fff;
    font-size: 15px;
    text-transform: capitalize;
    font-weight: 400;
    font-family: var(--font-family-primary);
    height: 50px;
}

.MuiBox-root.tabsHeader {
    width: 100%;
}

.tab.MuiButtonBase-root {
    min-height: 60px;
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 50%;
}

.MuiTypography-root.fromUploadText {
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
    text-transform: capitalize;
}

.MuiTypography-root.selectedCardTitle {
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #E4E5ED;
    line-height: 20px;
    font-size: 16px;
    text-transform: capitalize;
    margin-bottom: 16px;
}

.MuiDialogTitle-root.modalTitle {
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #E4E5ED;
    line-height: 20px;
    font-size: 16px;
    text-transform: capitalize;
}

.MuiGrid-root.uploadImageContainer {
    padding: 0px 20px;
    margin-top: 10px;
}

.MuiTypography-root.uploadText {
    color: #bbb;
    align-items: center;
}

.MuiPaper-root.UploadCard {
    margin-top: 10px;
    height: 175px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 2px dashed #aaa;
    border-radius: 8px;
    /* cursor: pointer; */
    overflow: hidden;
    gap: 10px;
    position: relative;
}

.MuiPaper-root.UploadCardPod {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border-radius: 8px;
    cursor: pointer;
    overflow: hidden;
    gap: 10px;
    position: relative;
    border: 2px dashed #aaa;
}

.MuiBox-root.uploadBox {
    text-align: center;
    position: relative;
}

.DeletedIcon {
    position: absolute;
    bottom: 5%;
    right: 2%;
}

.MuiPaper-root.promptCard {
    margin-top: 30px;
    border-radius: 8px;
    cursor: pointer;
    overflow: hidden;
    --Paper-shadow: none !important;
    background-color: transparent !important;
}

.MuiBox-root.promptContainer {
    width: 100%;
}

.promptImageContainer {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: space-between;
    margin-bottom: 10px;
    cursor: default;
}

.MuiButtonBase-root.play {
    cursor: pointer;
}

.MuiButtonBase-root.pause {
    cursor: not-allowed;
}

.containerbtn {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-top: 10px;
}

.MuiFormControl-root.MuiTextField-root.textField {
    width: 100%;
}

.MuiButtonBase-root.countButton {
    background-color: #3e3e5f;
    min-width: 25px;
    height: 24px;
    padding: 0;
}

/* .MuiBox-root.countContainer {
    width: 25%;
} */

.MuiGrid-root.countGrid {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    
}

.MuiPaper-root.countCard {
    margin-top: 0px;
    --Paper-shadow: none !important;
    background-color: transparent !important;
    padding-bottom: 20px;
}

.promptImageWrapper {
    display: flex;
    gap: 5px;
    align-items: center;
}

.MuiTypography-root.promptText {
    color: #FFFFFF;
    /* font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px; */
}

.MuiTypography-root.videoPromptText {
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #E4E5ED;
    font-size: 16px;
    text-transform: capitalize;
    margin: 10px 0px;
    line-height: 1.5;
    max-height: calc(1.5em * 5);
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #888 transparent;
}
.MuiTypography-root.linkTextyoutube{
    color: rgb(18, 110, 247);
    font-family: var(--font-family-primary);
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    text-decoration: underline;
}

.MuiBox-root.promptBox {
    margin-bottom: 16px;
}

/* videoComponent page css */
.MuiGrid-root.videoComponentContainer {
    background-color: #292B49;
    border: 1px solid #51546F;
    /* width: 100%; */
    height: 800px;
}

.MuiGrid-root.contentStudioContainer {
    flex-direction: row;
    max-width: 100%;
}

.MuiGrid-root.videoComponentContainer {
    /* max-width: 600px; */
    position: relative;
    margin: auto;
}
.MuiBox-root.videoComponentContent{
        height: calc(100vh - 11rem);
    overflow-y: auto;
}

.MuiBox-root.videoCard {
    width: 100%;
    position: relative;
}

.MuiPaper-root.videoCardPlaceholder {
    cursor: not-allowed;
}

.MuiPaper-root.videoSearchText {
    font-size: 12px;
    font-weight: 400;
    color: #C2C2C2;
    font-family: var(--font-family-primary);
    text-transform: capitalize;
}

.MuiStack-root.videoStack {
    position: relative;
    margin-top: 1rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 8px;
}

.MuiGrid-root.videoStack {
    position: relative;
    margin-top: 0.5rem;
}

.MuiCardMedia-root.videoCardImagePrompt {
    width: 50%;
    height: 50%;
    object-fit: cover;

}

.MuiButtonBase-root.generateButton {
    background-color: #69319D;
    color: #FDFCFF;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px;
    text-transform: capitalize;
    padding: 5px 12px;
    border-radius: 10px;
}

.MuiButtonBase-root.generateButton.Mui-disabled {
    color: rgba(253, 252, 255, 0.5);
    background-color: #262839;
}

.MuiCircularProgress-root {
    color: #fff !important;
}

.MuiPaper-root.selected {
    width: 17%;
    cursor: pointer;
    margin: 0px !important;
    border-radius: 0px;
    height: 140px;
}

.MuiPaper-root.unselected {
    cursor: pointer;
    width: 17%;
    margin: 0px !important;
    border-radius: 0px;
    height: 140px;
}

.MuiPaper-root.borderImage {
    border: 3px solid rgba(253, 247, 247, 1);
    opacity: 1;
}

.MuiPaper-root.opacityImage {
    opacity: 0.5;
    border-radius: none;
}


.MuiCardMedia-root.videoCardImage {
    width: 100%;
    height: 100%;
    object-fit: contain;
    aspect-ratio: calc(1/1);
}

.blurImage {
    filter: blur(2px);
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: contain !important;
     aspect-ratio: calc(1/1);
}
.blurMansoryImage{
    filter: blur(2px);
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: contain !important;
}
.videoMansoryImage {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-fit: contain !important;
}

.videoWrapper {
    position: relative;
    overflow: hidden;
    height: 100%;
    padding-top: 60.25%;
}

.imageWrapper {
    position: relative;
    overflow: hidden;
    height: 100%;
    padding-top: 56.25%;
}

.videoWrapper video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
}

.MuiPaper-root.thumbnailCard {
    width: 100%;
    position: relative;
    margin-top: 16px;
}

.MuiPaper-root.thumbnailCard .MuiCardMedia-root {
    width: 135px;
    height: 85px;
}

.videoControls {
    display: flex;
    align-items: center;
    padding: 8px;
    /* position: absolute; */
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(to bottom, #27252500 0%, #26212199 60%);
}

.MuiBox-root.videoDescription {
    display: flex;
    gap: 10px;
    width: 100%;
    margin-top: 16px;
    align-items: center;
}

.MuiTypography-root.videoTitle {
    color: #EEEEF2 !important;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px;
}

.MuiChip-root.videoChip {
    background-color: #363962;

}

.MuiChip-root.videoChip .MuiChip-label {
    color: #EEEEF2 !important;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 12px;
}

.MuiBox-root.videoThumbnails {
    width: 100%;
    margin-top: 10px;
    position: relative;
    overflow-y: auto;
   /* height: calc(100dvh - 45rem); */
    min-height: 320px;
}
.MuiBox-root.videoThumbnails.cinemotioncontainer {
    min-height: 650px;
}

.videoSlider {
    flex: 1 1;
    margin: 0 16px;
}

.MuiSlider-track {
    background-color: #692AA5 !important;
    border: 1px solid #692AA5 !important;
}

/* span {
    color: #fff !important;
} */

.MuiSlider-rail {
    background-color: #FFFFFF80 !important;
    border: 1px solid #FFFFFF80 !important;
}

.MuiPaper-root.fullscreen {
    max-width: 100vw !important;
    height: 100vh !important;
}

.MuiTypography-root.videoTime {
    background-color: #534C4C80;
    padding: 4px;
    border-radius: 10px;
}

.MuiBox-root.videoHeader {
    position: absolute;
    top: 0;
    right: 4%;
}

.MuiBox-root.videoFooter {
    position: absolute;
    bottom: 15%;
    right: 5%;
}

.downloadIcon {
    width: 30px;
    height: 30px;
}

.MuiBox-root.videoLoader {
    position: absolute;
    top: 40%;
    left: 40%;
}

/* Camera controls */
.MuiPaper-root.cameraControlCard {
    background-color: #252643;
    height: 100%;
    overflow-y: auto;
}

.MuiPaper-root.cameraControlItem {
    --Paper-shadow: none !important;
    width: 100%;
    height: 100%;
}

/* .MuiCardMedia-root.cameraControlImage {
    width: 125px;
    height: 86px; 
    border-radius: 10px;
} */

.MuiTypography-root.cameraControlTitle {
    color: #E4E5ED;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 16px;
    padding: 20px 20px 0px 20px;
}

.MuiDivider-root.studioDivider {
    border: 1.5px solid #3F405D;
    margin-top: 10px;
}

.MuiDivider-root.modalDivider {
    border: 1px solid #4c4f6e;
}

.MuiCardContent-root.cameraControlContainer {
    position: relative;

}

.MuiCardContent-root.cameraControlImageContainer {
    position: relative;
    padding: 20px 0px 0px 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.MuiCardContent-root.cameraControlContent {
    padding: 0px 0px 0px 0px !important;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;

}

.MuiTypography-root.cameraControlTitle {
    padding: 20px 20px 0px 20px;
}

.MuiButtonBase-root.cameraControlButton {
    padding: 0px;
}

.MuiButtonBase-root.cameraControlButton .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
}

/* Base shared styles */
.MuiBox-root.cameraControlBox,
.MuiBox-root.cameraControlBoxRight {
    background-color: #343434;
    border: 0.5px solid #50435C;
    padding: 0px 4px;
    border-radius: 10px;
    cursor: pointer;
}

.MuiBox-root.cameraControlBox {
    text-align: left;
}

.MuiBox-root.cameraControlBoxRight {
    text-align: right;
}

/* Hover effect shared */
.MuiBox-root.cameraControlBox:hover,
.MuiBox-root.cameraControlBoxRight:hover {
    border: 1px solid #8D49cE;
    background-color: #4B4B4B;
}


.MuiBox-root.cameraControlBoxNosubTitle {
    background-color: #3b3c56;
    border: 0.5px solid #50435C;
    padding: 10px 20px;
    border-radius: 10px;
    margin-top: 10px;
    display: flex;
    gap: 20px;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    cursor: pointer;
}

.MuiCardContent-root.cameraControlContent {
    margin-top: 10px;
}

.MuiTypography-root.buttontitle {
    color: #E4E5ED;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 12px;
}

.MuiTypography-root.finalText {
    color: #E4E5ED;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 12px;
    padding: 0px 20px;
}

.MuiGrid-root.cameraControlGrid {
    cursor: pointer;
    align-items: center;
}

/* WithoutContent Text */
.MuiPaper-root.videoPlaceholderCard {
    height: 316px;
}

.MuiBox-root.videoPlaceholderContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
}

.MuiTypography-root.videoPlaceholderText {
    text-align: center;
    color: #C2C2C2;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

/* scroll global style */
.cameraControlContainer::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
    background-clip: content-box;
    padding: 20px 0;
}

.cameraControlContainer::-webkit-scrollbar-thumb {
    background: #515261;
    border-radius: 10px;
    min-height: 10px;
}

.cameraControlContainer::-webkit-scrollbar {
    width: 4px;
}

/* visiblityIcon */
.MuiBox-root.visibilityIconContainer {
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(55, 54, 54, 0.25);
    height: 90%;
    border-radius: 10px;
}

.visibilityIcon {
    width: 30px;
    height: 30px;
}

.MuiBox-root.cameraControlImageOverlay {
    position: absolute;
    right: 5%;
    top: 15%;
    bottom: 0;
}

.cameraImage {
    width: 20px;
    object-fit: cover;
}

.MuiTypography-root.mainDialogTitle {
    background-color: #2D3055;
    width: 98%;
    border-radius: 10px;
}

.MuiTypography-root.videoLoadingText {
    color: #fff;
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: 16px;
    text-transform: capitalize;
}

.MuiBox-root.upload-studio-container {
    cursor: pointer;
    margin-top: 1rem;
}

.upload-existing-studio {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    overflow-y: auto;
    height: 130px;
    justify-content: center;
}

.upload-existing-studio::-webkit-scrollbar {
    width: 4px;
}

.upload-existing-studio::-webkit-scrollbar-thumb {
    background-color: #ECEDF8;
    border-radius: 10px;
}

@media screen and (min-width: 768px) {
    .upload-existing-studio {
        justify-content: flex-start;
        gap: 5px;
    }
}

@media screen and (min-width: 1023px) {
    .upload-existing-studio {
        justify-content: flex-start;
        gap: 10px;
    }
}

/* media queries */
@media screen and (min-width: 768px) {
    .MuiGrid-root.uploadImageContainer {
        padding: 0px 20px;
    }

    .MuiGrid-root.mainContainerStudio {
        padding: 0px 20px;
        justify-content: flex-start;
        align-items: flex-start;
    }
}

/* ModalPopup css */
.MuiDialog-root.modalMainContainer .MuiDialog-container {
    background: rgba(26, 24, 27, 0.8);
    align-items: flex-start;
}

.MuiDialog-root.modalMainContainer .MuiDialog-container .MuiPaper-root {
    position: relative;
    border-radius: 20px;
    z-index: 1;
    background: transparent;
    box-shadow: 0px 4px 10px rgba(192, 191, 193, 0.25);
    overflow: hidden;
    position: relative;
    top: 0%;
}

.MuiDialog-root.modalMainContainer .MuiDialog-container .MuiPaper-root::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background-color: #2D3055;
    z-index: -1;
    border-radius: 20px;
}

.MuiDialog-root.modalMainContainerImage .MuiDialog-container {
    background: rgba(26, 24, 27, 0.8);
    align-items: center;
}

.MuiDialog-root.modalMainContainerImage .MuiDialog-container .MuiPaper-root {
    position: relative;
    border-radius: 20px;
    z-index: 1;
    background: transparent;
    box-shadow: 0px 4px 10px rgba(192, 191, 193, 0.25);
    overflow: hidden;
    position: relative;
    top: 0%;
}

.MuiDialog-root.modalMainContainerImage .MuiDialog-container .MuiPaper-root::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    background-color: #2D3055;
    z-index: -1;
    border-radius: 20px;
}

.MuiTypography-root.modalTitle {
    background-color: #2D3055;
    color: #fff;
}

.MuiBox-root.modalTitleBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
}

.MuiTypography-root.modalTitleText {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 20px;
    font-family: var(--font-family-primary);
    font-weight: 600;
    text-transform: capitalize;
    color: #E4E5ED;
}

.cameracontrolIcon {
    width: 30px;
    height: 30px;
}

.MuiDialogContent-root.modelContent {
    background-color: #2D3055;
    color: #fff;
    padding: 24px;
    overflow: hidden;
}

.videoImage {
    width: 100%;
    /* border-radius: 8px; */
}

.videoDataImage {
    width: 500px;
    height: 320px;
    object-fit: contain;
}

.MuiButtonBase-root.checkBoxImage {
    position: absolute;
    top: 8px;
    right: 8px;
    color: white;
}

.videoContainer {
    position: relative;
}

.MuiDialogActions-root.modalActions {
    display: flex;
    justify-content: center;
    background-color: #2D3055;
    padding: 0px 0px 40px 0px;
    justify-content: center;
}

.MuiButtonBase-root.modalButton {
    background-color: #6A1B9A;
    color: #FDFCFF;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px;
    text-transform: capitalize;
    width: 250px;
    border-radius: 7px;
    padding: 12px 0px;
}

.MuiGrid-root.modalGridContainer {
    justify-content: center;
    padding-bottom: 0px !important;
}

.MuiDialog-root.modalContainer .MuiDialog-container {
    background: rgba(26, 24, 27, 0.8);
}

.MuiDialog-root.modalContainer .MuiDialog-container .MuiPaper-root {
    --Paper-shadow: none !important;
}

.MuiTypography-root.closeIconContainer {
    display: flex;
    justify-content: end;
    position: absolute;
    right: 0;
}

.MuiButtonBase-root.closeIconbutton {
    position: absolute;
    top: -7px;
    right: 0;
    color: white;
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
}

.MuiButtonBase-root.closeIconbutton .MuiSvgIcon-root {
    width: 2rem;
    height: 2rem;
}

.MuiBox-root.gheerButton {
    position: absolute;
    top: 10%;
    right: 8px;
    translate: translateY(-50%);
    z-index: 2;
}

.gheerImage {
    width: 30px;
    height: 30px;
}

.MuiTypography-root.text-bracket {
    color: rgba(141, 73, 206, 1);
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 16px;
    display: inline;
}

.MuiTypography-root.text-normal {
    color: rgba(255, 255, 255, 1);
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 16px;
    display: inline;
}

/* .MuiTypography-root.previewTexts{
    height: 10rem;
    overflow-y: auto;
    padding: 10px 10px;
  
} */
.previewTextContainer {
    border: 1px solid rgba(252, 250, 255, 0.5);
    padding: 10px 10px;
    border-radius: 10px;
}

.modalVideo {
    width: 98%;
    height: 50%;
    /* object-fit: cover; */
    aspect-ratio: calc(1/1);
    border-radius: 10px;
}

.MuiBox-root.videoUploadCard {
    height: 320px;
    position: relative;
}
.MuiBox-root.videoUploadCardReels {
    height: 320px;
    position: relative;
}

.videoLoadingContainer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.gheerIcon {
    width: 30px;
    height: 30px;
}

.MuiBox-root.videoDataImageContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
}

.MuiBox-root.videoPromptContainer {
    padding: 0px 20px;
}


/* Studio Home */
.MuiGrid-root.studio-home-card {
    padding: 0px 40px 40px 40px;
    overflow-y: auto;
    height: 80vh;
    background: linear-gradient(to bottom, #2E335A, #1C1B33)
}


.MuiBox-root.card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.MuiBox-root.studio-home-header {
    padding: 20px 25px;
    margin-bottom: 1rem;
}

/* coming soon page */
.MuiBox-root.coming-soon-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    z-index: 1;
    overflow: hidden;
}

.MuiBox-root.coming-soon-container::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 0.1;
    z-index: -1;
}

.MuiTypography-root.coming-soon-title {
    font-family: var(--font-family-primary);
    font-weight: 700;
    color: #E4E5ED;
    font-size: 32px;
    text-transform: capitalize;
    margin-top: 20px;
}

.MuiTypography-root.coming-soon-description {
    font-family: var(--font-family-primary);
    font-weight: 600;
    color: #E4E5ED;
    font-size: 16px;
    text-transform: capitalize;
    margin-top: 0;
}

.MuiBox-root.coming-soon-button-container {
    margin-top: 20px;
}

.MuiCardContent-root.card-content {
    background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);
    border-radius: 0px 0px 10px 10px;
}

.MuiBox-root.main-studio {
    background: linear-gradient(to bottom, #2E335A, #1C1B33);
    padding: 0px;
}

.MuiTypography-root.studio-home-title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    color: #E4E5ED;
    font-size: 20px;
    text-transform: capitalize;
}

.MuiTypography-root.card-description {
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #E4E5ED;
    font-size: 16px;
    text-transform: capitalize;
    margin-top: 0;
    min-height: 40px;
}

.MuiTypography-root.studio-home-description {
    font-family: var(--font-family-primary);
    font-weight: 400;
    color: #E4E5ED;
    font-size: 16px;
    text-transform: capitalize;
    margin-top: 0;
    line-height: 1.5;
    margin-bottom: 1rem;
}

.MuiChip-root.coming-soon-chip {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #CADCFC;
}

.MuiChip-root.coming-soon-chip .MuiChip-label {
    color: #000 !important;
    font-family: var(--font-family-primary);
    font-weight: 500;
    font-size: 12px;
}

.coming-soon-banner {
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    width: 125px;
    z-index: 10;
    pointer-events: none;
}

.MuiBox-root.previewImageBox {
    display: flex;
    flex-direction: column;
    gap: 12px;
}


@media screen and (min-width: 768px) {
    .modalVideo {
        aspect-ratio: calc(21/9);
    }

    .MuiDialog-root.modalMainContainer .MuiDialog-container .MuiPaper-root {
        top: 15%;
    }

    .MuiBox-root.previewImageBox {
        flex-direction: row;
    }

    .MuiGrid-root.studio-home-card {
        height: 80vh;
    }

}

@media screen and (min-width: 1023px) {
    .MuiGrid-root.studio-home-card {
        height: 90vh;
    }
   

}


@media screen and (min-width: 1440px) {
    .MuiGrid-root.mainContainerStudio {
        align-items: flex-start;
        padding: 0px 20px;
        justify-content: center;
    }

    .modalVideo {
        aspect-ratio: calc(21/9);
    }

    .MuiBox-root.cameraControlContainer {
        overflow-y: auto;
        height: 100%;
    }

}

@media screen and (min-width: 1441px) {
    .MuiBox-root.cameraControlBox {
        padding: 0px 15px;

    }
}

@media screen and (min-width: 1920px) {
    .modalVideo {
        aspect-ratio: calc(16/9);
    }

    .waterMarkIcon {
        width: 150px;
    }


}

/* PodCast css */
.MuiGrid-root.podcastMainContainer {
    padding: 10px 40px;
    position: relative;
    height: calc(100vh - 169px);
    overflow-y: auto;
}

.MuiGrid-root.podcastCardleft {
    width: 100%;
    background-color: #292B49;
    display: block;
    padding: 20px;
    position: relative;
}

.MuiBox-root.uploadImageContainer {
    width: 100%;
    position: relative;
    height: 100%;
    padding: 20px 10px 20px 20px;
}

.MuiBox-root.inputContainer {
    border: 2px dashed #aaa;
    border-radius: 8px;
    height: 173px;
    width: 100%;
}

.MuiBox-root.uploadImageText {
    position: absolute;
    top: 19%;
    /* left: 0; */
    display: flex;
    justify-content: center;
    text-align: center;
    width: 100%;
}

.uploadedImageContainer {
    text-align: center;
    position: relative;
}

.removeImageContainer {
    position: absolute;
    top: 30.5%;
    left: 37%;
}

.removeImageContainer .MuiSvgIcon-root {
    color: red;
}

.uploadedImage {
    width: 100%;
    height: 167px;
    object-fit: contain;
    border-radius: 8px;
}

.MuiTypography-root.uploadText {
    color: #EEEEF2;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 14px;
    text-transform: none;
    text-align: center;
}

.MuiBox-root.promptHeader {
    display: flex;
    justify-content: space-between;
    margin: 0px 0px 17px 0px;
    align-items: center;
    align-items: center;
}

.promptHeaderText {
    display: flex;
    align-items: center;
    gap: 5px;
}

.MuiBox-root.videoCardThumbnail {
    margin: 10px 0px;
}

.MuiBox-root.videoThumbnailCard {
    width: 100%;
    height: 100%;
    position: relative;
    margin-top: 10px;
    overflow-y: auto;

}

.MuiBox-root.videoThumbnailContainer {
    display: flex;
    align-items: center;
    gap: 0px;
    flex-wrap: wrap;
    width: 100%;
    min-height: 250px;
}

.videoThumbnail {
    width: 131px;
    height: 100px;
    object-fit: contain;
    border-radius: 8px;
    position: relative;
}

.MuiGrid-root.podcastCardRight {
    padding: 20px;
    padding-top: 0px !important;
}

.MuiBox-root.voiceInputContainer {
    display: flex;
    align-items: center;
    border: 1px solid #aaa;
    border-radius: 8px;
    padding: 4px 8px;
    background: #23244a;
}

.MuiFormControl-root.voiceOptionContainer {
    width: 100%;
}

.MuiFormControl-root.voiceOptionContainer .MuiFormGroup-root {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.MuiButtonBase-root.uploadButton {
    background-color: transparent;
    border: 1px solid #b3b0c1;
    color: #fff !important;
    text-transform: capitalize;
    cursor: pointer;
}

.MuiButtonBase-root.uploadButton.Mui-disabled {
    border: 1px solid #b3b0c1;
    cursor: not-allowed;
    pointer-events: visible;
}

.MuiInputBase-root.selectVoice {
    border: 1px solid #b3b0c1;
    width: 100%;
    height: 65px;
}

.MuiInputBase-root .MuiSvgIcon-root {
    color: #b3b0c1;
}

.selectVoice .MuiSelect-select {
    display: flex;
}

.MuiSelect-outlined {
    border-radius: 8px;
    border: 1px solid #b3b0c1;
}

.MuiInputBase-root.selectVoice .MuiSvgIcon-root {
    color: #b3b0c1;
}

.MuiFormControl-root.textField .Mui-disabled {
    cursor: not-allowed;
}

.videoImage {
    width: 100%;
    /* height: 350px; */
    object-fit: contain;
    opacity: 0.8;
}

.MuiBox-root.inputView {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
    width: 100%;
}
.MuiBox-root.aspectRatio{
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    margin: 20px 0px 10px 0px;
}

.MuiBox-root.width50 {
    width: 100%;
}

.MuiAvatar-root.avatarSelector {
    border: 2px solid #7F81A8;
    background-color: transparent;
}

.avatarImages {
    width: 30px;
    height: 30px;
    object-fit: contain;

}

.flagImages {
    width: 20px;
    height: 15px;
    object-fit: cover;
    border-radius: 4px;
}

.MuiBox-root.voiceOption {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: space-between;
}

.MuiInputBase-root.MuiSelect-select {
    display: flex;
    align-items: center;
}

.chipLabel .MuiChip-label {
    color: #fff !important;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 12px;
}

.MuiBox-root.GenerateButtonContainer {
    display: flex;
    justify-content: end;
    align-items: center;
    margin: 20px 0px 10px 0px;
}

.MuiSvgIcon-root.graphicIcon {
    width: 15px;
    height: 15px;
}

.MuiListSubheader-root.searchHeader {
    background-color: #1F2138;
    margin-bottom: 20px;
    padding: 0px;
    
}

.searchInput .MuiInputBase-input {
    background-color: #1F2138;

}

.MuiBox-root.searchBox {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    border: 0.5px solid #FFFFFF66;
    border-radius: 8px;
}

.MuiBox-root.voiceList {
    overflow-y: auto;
    height: 200px;
}

.MuiBox-root.menuSelected {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
    align-items: center;
    
}


.MuiBox-root.podcastButtonContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
}

.GenerateButtonContainer .MuiButtonBase-root {
    /* width: 100%; */
    height: 47px;
}

.MuiBox-root.width25 {
    width: 100%;
}

.MuiBox-root.width75 {
    width: 100%;
}

.MuiChip-root.hedraStyle {
    background-color: #494B6B;
    border-radius: 10px;
    cursor: pointer;
}

.hedraStyle .MuiChip-label {
    color: #B1B3D6 !important;
    font-family: var(--font-family-primary);
    font-weight: 400;
    font-size: 13px;
}

.MuiBox-root.headerBox {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 10px;
}

.flagBox {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
}
.MuiSlider-thumb{
    background-color: #692AA5 !important;
}
.aspectRatio .MuiSelect-select{
    padding: 12.5px 14px;
}
.podcastUpload-Container{
    min-height: 250px;
}
@media screen and (min-width: 768px) {
 .MuiBox-root.videoThumbnailContainer{
    gap: 5px;
    justify-content: flex-start;
 }
 .MuiBox-root.promptHeader {
    display: flex;
    justify-content: space-between;
    margin: 10px 0px 5px 0px;
    align-items: center;
    gap: 0px;
    flex-direction: row;
}
 .videoThumbnail {
        width: 154px;
    }
    
}

@media screen and (min-width: 1024px) {
    .MuiBox-root.inputView {
        flex-direction: row;
        align-items: center;
    }
    .MuiBox-root.aspectRatio{
        flex-direction: row;
        align-items: center;
    }

    .MuiBox-root.width50 {
        width: 50%;
    }

    .MuiBox-root.width25 {
        width: 25%;
    }

    .MuiBox-root.width75 {
        width: 75%;
    }

    .MuiBox-root.uploadImageText {
        width: 50%;
    }

    .MuiBox-root.podcastwidth {
        width: 33.33335%;
    }

    .MuiBox-root.podcastVoiceContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
        margin-top: 20px;
        width: 100%;
    }

    .podcastButtonContainer {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }

    .MuiGrid-root.podcastMainContainer {
        height: calc(100vh - 135px);
    }

    .videoThumbnail {
        width: 200px;
    }

    .MuiBox-root.uploadPromptHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .videoWrapper {
        padding-top: 36.25%
    }
    .videoWrapperReels{
        padding-top: 63.25%;
    }
 
.cinemotion-upload>.MuiBox-root>.my-masonry-grids{
    height: calc(100dvh - 44rem);
    overflow-y: auto;
    min-height: 380px;
}
.cinemotion-upload>.MuiBox-root>.uploaded-images-grid{
    height: calc(100dvh - 44rem);
    overflow-y: auto;
    min-height: 380px;

}
.podcastUpload-Container>.MuiBox-root>.my-masonry-grids{
    height: calc(100dvh - 44rem);
    overflow-y: auto;
    min-height: 250px;
}
.podcastUpload-Container>.MuiBox-root>.uploaded-images-grid{
    height: calc(100dvh - 44rem);
    overflow-y: auto;
    min-height: 250px;

}

}
@media screen and (min-width: 1440px) {
.cinemotion-upload>.MuiBox-root>.my-masonry-grids{
    min-height: 410px;
}
.cinemotion-upload>.MuiBox-root>.uploaded-images-grid{
    min-height: 410px;

}
}
@media screen and (min-width: 1920px) {
.cinemotion-upload>.MuiBox-root>.my-masonry-grids{
    min-height: 520px;
}
.cinemotion-upload>.MuiBox-root>.uploaded-images-grid{
    min-height: 520px;

}
}

@media screen and (max-width: 460px) {
.MuiGrid-root.podcastMainContainer {
    padding: 2px;
}
.MuiBox-root.videoThumbnails {
    height:100%;
}
/* Camera controls */
.MuiPaper-root.cameraControlCard {
 height: 100%;
}
.videoThumbnail {
    width: 118px;
}
.uploadContainer {
    height:100%;
}
.MuiGrid-root.uploadImageContainer {
padding-bottom: 20px;
}


}`, "",{"version":3,"sources":["webpack://./src/components/Studio/Studio.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;;IAEzB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,wCAAwC;AAC5C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;;AAElC;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd;;sBAEkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,iCAAiC;AACrC;AACA;IACI,wBAAwB;IACxB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;QACQ,2BAA2B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;;AAErB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;KAC7B,uBAAuB;AAC5B;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,SAAS;IACT,OAAO;IACP,WAAW;IACX,mEAAmE;AACvE;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;GACjB,kCAAkC;IACjC,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;;GAEG;;AAEH;IACI,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;AAChB;;AAEA;;;;GAIG;;AAEH;IACI,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,uBAAuB;;AAE3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,uBAAuB;AACvB;;IAEI,yBAAyB;IACzB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;;IAEI,yBAAyB;IACzB,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,2BAA2B;QAC3B,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,SAAS;IACb;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,uBAAuB;IAC3B;AACJ;;AAEA,mBAAmB;AACnB;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,uBAAuB;IACvB,kDAAkD;IAClD,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,uBAAuB;IACvB,kDAAkD;IAClD,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;;;;;GAKG;AACH;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA,gBAAgB;AAChB;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ;AACJ;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,yDAAuD;IACvD,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6FAA6F;IAC7F,gCAAgC;AACpC;;AAEA;IACI,wDAAwD;IACxD,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,YAAY;IACZ,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;;AAGA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;AAEJ;;AAEA;IACI;QACI,YAAY;IAChB;;;AAGJ;;;AAGA;IACI;QACI,uBAAuB;QACvB,iBAAiB;QACjB,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;AAEJ;;AAEA;IACI;QACI,iBAAiB;;IAErB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;IAChB;;;AAGJ;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,SAAS;IACT,mBAAmB;;AAEvB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;AACA;CACC;IACG,QAAQ;IACR,2BAA2B;CAC9B;CACA;IACG,aAAa;IACb,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;CACC;QACO,YAAY;IAChB;;AAEJ;;AAEA;IACI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI;IACJ;IACA;QACI,mBAAmB;IACvB;;AAEJ;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;;AAErB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;AACA;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;;AAErB;AACA;AACA;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;;AAErB;AACA;;AAEA;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA,oBAAoB;AACpB;CACC,YAAY;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;AACA,oBAAoB;AACpB;;;AAGA","sourcesContent":[".MuiGrid-root.mainContainerStudio {\n    margin-top: 10px;\n    overflow-y: auto;\n    height: calc(100vh - 9rem);\n    align-items: flex-start;\n    padding: 0px 20px;\n    justify-content: center;\n}\n\n/* UploadImage page css */\n.uploadContainer {\n    background-color: #292B49;\n    \n    overflow: hidden;\n}\n\n\n.uploadTextContainer {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n\n}\n\n.uploadAddIcon {\n    cursor: pointer;\n}\n\n.tabsContainer {\n    flex-grow: 1;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n}\n\n.tabs {\n    border-bottom: 2px solid #565A78;\n}\n\n.tabs .MuiTabs-indicator {\n    border: 1.5px solid #fff;\n}\n\n.tabs .MuiTabs-flexContainer {\n    min-height: 60px;\n}\n\n.MuiButtonBase-root.tab {\n    color: #fff;\n    font-size: 15px;\n    text-transform: capitalize;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    height: 50px;\n}\n\n.MuiBox-root.tabsHeader {\n    width: 100%;\n}\n\n.tab.MuiButtonBase-root {\n    min-height: 60px;\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    width: 50%;\n}\n\n.MuiTypography-root.fromUploadText {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #fff;\n    line-height: 20px;\n    font-size: 16px;\n    text-transform: capitalize;\n}\n\n.MuiTypography-root.selectedCardTitle {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #E4E5ED;\n    line-height: 20px;\n    font-size: 16px;\n    text-transform: capitalize;\n    margin-bottom: 16px;\n}\n\n.MuiDialogTitle-root.modalTitle {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #E4E5ED;\n    line-height: 20px;\n    font-size: 16px;\n    text-transform: capitalize;\n}\n\n.MuiGrid-root.uploadImageContainer {\n    padding: 0px 20px;\n    margin-top: 10px;\n}\n\n.MuiTypography-root.uploadText {\n    color: #bbb;\n    align-items: center;\n}\n\n.MuiPaper-root.UploadCard {\n    margin-top: 10px;\n    height: 175px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 2px dashed #aaa;\n    border-radius: 8px;\n    /* cursor: pointer; */\n    overflow: hidden;\n    gap: 10px;\n    position: relative;\n}\n\n.MuiPaper-root.UploadCardPod {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: transparent;\n    border-radius: 8px;\n    cursor: pointer;\n    overflow: hidden;\n    gap: 10px;\n    position: relative;\n    border: 2px dashed #aaa;\n}\n\n.MuiBox-root.uploadBox {\n    text-align: center;\n    position: relative;\n}\n\n.DeletedIcon {\n    position: absolute;\n    bottom: 5%;\n    right: 2%;\n}\n\n.MuiPaper-root.promptCard {\n    margin-top: 30px;\n    border-radius: 8px;\n    cursor: pointer;\n    overflow: hidden;\n    --Paper-shadow: none !important;\n    background-color: transparent !important;\n}\n\n.MuiBox-root.promptContainer {\n    width: 100%;\n}\n\n.promptImageContainer {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    cursor: default;\n}\n\n.MuiButtonBase-root.play {\n    cursor: pointer;\n}\n\n.MuiButtonBase-root.pause {\n    cursor: not-allowed;\n}\n\n.containerbtn {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin-top: 10px;\n}\n\n.MuiFormControl-root.MuiTextField-root.textField {\n    width: 100%;\n}\n\n.MuiButtonBase-root.countButton {\n    background-color: #3e3e5f;\n    min-width: 25px;\n    height: 24px;\n    padding: 0;\n}\n\n/* .MuiBox-root.countContainer {\n    width: 25%;\n} */\n\n.MuiGrid-root.countGrid {\n    display: flex;\n    gap: 10px;\n    justify-content: space-between;\n    \n}\n\n.MuiPaper-root.countCard {\n    margin-top: 0px;\n    --Paper-shadow: none !important;\n    background-color: transparent !important;\n    padding-bottom: 20px;\n}\n\n.promptImageWrapper {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n}\n\n.MuiTypography-root.promptText {\n    color: #FFFFFF;\n    /* font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px; */\n}\n\n.MuiTypography-root.videoPromptText {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #E4E5ED;\n    font-size: 16px;\n    text-transform: capitalize;\n    margin: 10px 0px;\n    line-height: 1.5;\n    max-height: calc(1.5em * 5);\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #888 transparent;\n}\n.MuiTypography-root.linkTextyoutube{\n    color: rgb(18, 110, 247);\n    font-family: var(--font-family-primary);\n    font-size: 16px;\n    font-weight: 400;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n.MuiBox-root.promptBox {\n    margin-bottom: 16px;\n}\n\n/* videoComponent page css */\n.MuiGrid-root.videoComponentContainer {\n    background-color: #292B49;\n    border: 1px solid #51546F;\n    /* width: 100%; */\n    height: 800px;\n}\n\n.MuiGrid-root.contentStudioContainer {\n    flex-direction: row;\n    max-width: 100%;\n}\n\n.MuiGrid-root.videoComponentContainer {\n    /* max-width: 600px; */\n    position: relative;\n    margin: auto;\n}\n.MuiBox-root.videoComponentContent{\n        height: calc(100vh - 11rem);\n    overflow-y: auto;\n}\n\n.MuiBox-root.videoCard {\n    width: 100%;\n    position: relative;\n}\n\n.MuiPaper-root.videoCardPlaceholder {\n    cursor: not-allowed;\n}\n\n.MuiPaper-root.videoSearchText {\n    font-size: 12px;\n    font-weight: 400;\n    color: #C2C2C2;\n    font-family: var(--font-family-primary);\n    text-transform: capitalize;\n}\n\n.MuiStack-root.videoStack {\n    position: relative;\n    margin-top: 1rem;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    gap: 8px;\n}\n\n.MuiGrid-root.videoStack {\n    position: relative;\n    margin-top: 0.5rem;\n}\n\n.MuiCardMedia-root.videoCardImagePrompt {\n    width: 50%;\n    height: 50%;\n    object-fit: cover;\n\n}\n\n.MuiButtonBase-root.generateButton {\n    background-color: #69319D;\n    color: #FDFCFF;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px;\n    text-transform: capitalize;\n    padding: 5px 12px;\n    border-radius: 10px;\n}\n\n.MuiButtonBase-root.generateButton.Mui-disabled {\n    color: rgba(253, 252, 255, 0.5);\n    background-color: #262839;\n}\n\n.MuiCircularProgress-root {\n    color: #fff !important;\n}\n\n.MuiPaper-root.selected {\n    width: 17%;\n    cursor: pointer;\n    margin: 0px !important;\n    border-radius: 0px;\n    height: 140px;\n}\n\n.MuiPaper-root.unselected {\n    cursor: pointer;\n    width: 17%;\n    margin: 0px !important;\n    border-radius: 0px;\n    height: 140px;\n}\n\n.MuiPaper-root.borderImage {\n    border: 3px solid rgba(253, 247, 247, 1);\n    opacity: 1;\n}\n\n.MuiPaper-root.opacityImage {\n    opacity: 0.5;\n    border-radius: none;\n}\n\n\n.MuiCardMedia-root.videoCardImage {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    aspect-ratio: calc(1/1);\n}\n\n.blurImage {\n    filter: blur(2px);\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    object-fit: contain !important;\n     aspect-ratio: calc(1/1);\n}\n.blurMansoryImage{\n    filter: blur(2px);\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    object-fit: contain !important;\n}\n.videoMansoryImage {\n    width: 100%;\n    height: 100%;\n    border-radius: 10px;\n    object-fit: contain !important;\n}\n\n.videoWrapper {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    padding-top: 60.25%;\n}\n\n.imageWrapper {\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n    padding-top: 56.25%;\n}\n\n.videoWrapper video {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    /* object-fit: cover; */\n}\n\n.MuiPaper-root.thumbnailCard {\n    width: 100%;\n    position: relative;\n    margin-top: 16px;\n}\n\n.MuiPaper-root.thumbnailCard .MuiCardMedia-root {\n    width: 135px;\n    height: 85px;\n}\n\n.videoControls {\n    display: flex;\n    align-items: center;\n    padding: 8px;\n    /* position: absolute; */\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    background: linear-gradient(to bottom, #27252500 0%, #26212199 60%);\n}\n\n.MuiBox-root.videoDescription {\n    display: flex;\n    gap: 10px;\n    width: 100%;\n    margin-top: 16px;\n    align-items: center;\n}\n\n.MuiTypography-root.videoTitle {\n    color: #EEEEF2 !important;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px;\n}\n\n.MuiChip-root.videoChip {\n    background-color: #363962;\n\n}\n\n.MuiChip-root.videoChip .MuiChip-label {\n    color: #EEEEF2 !important;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 12px;\n}\n\n.MuiBox-root.videoThumbnails {\n    width: 100%;\n    margin-top: 10px;\n    position: relative;\n    overflow-y: auto;\n   /* height: calc(100dvh - 45rem); */\n    min-height: 320px;\n}\n.MuiBox-root.videoThumbnails.cinemotioncontainer {\n    min-height: 650px;\n}\n\n.videoSlider {\n    flex: 1;\n    margin: 0 16px;\n}\n\n.MuiSlider-track {\n    background-color: #692AA5 !important;\n    border: 1px solid #692AA5 !important;\n}\n\n/* span {\n    color: #fff !important;\n} */\n\n.MuiSlider-rail {\n    background-color: #FFFFFF80 !important;\n    border: 1px solid #FFFFFF80 !important;\n}\n\n.MuiPaper-root.fullscreen {\n    max-width: 100vw !important;\n    height: 100vh !important;\n}\n\n.MuiTypography-root.videoTime {\n    background-color: #534C4C80;\n    padding: 4px;\n    border-radius: 10px;\n}\n\n.MuiBox-root.videoHeader {\n    position: absolute;\n    top: 0;\n    right: 4%;\n}\n\n.MuiBox-root.videoFooter {\n    position: absolute;\n    bottom: 15%;\n    right: 5%;\n}\n\n.downloadIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.MuiBox-root.videoLoader {\n    position: absolute;\n    top: 40%;\n    left: 40%;\n}\n\n/* Camera controls */\n.MuiPaper-root.cameraControlCard {\n    background-color: #252643;\n    height: 100%;\n    overflow-y: auto;\n}\n\n.MuiPaper-root.cameraControlItem {\n    --Paper-shadow: none !important;\n    width: 100%;\n    height: 100%;\n}\n\n/* .MuiCardMedia-root.cameraControlImage {\n    width: 125px;\n    height: 86px; \n    border-radius: 10px;\n} */\n\n.MuiTypography-root.cameraControlTitle {\n    color: #E4E5ED;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 16px;\n    padding: 20px 20px 0px 20px;\n}\n\n.MuiDivider-root.studioDivider {\n    border: 1.5px solid #3F405D;\n    margin-top: 10px;\n}\n\n.MuiDivider-root.modalDivider {\n    border: 1px solid #4c4f6e;\n}\n\n.MuiCardContent-root.cameraControlContainer {\n    position: relative;\n\n}\n\n.MuiCardContent-root.cameraControlImageContainer {\n    position: relative;\n    padding: 20px 0px 0px 0px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.MuiCardContent-root.cameraControlContent {\n    padding: 0px 0px 0px 0px !important;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: flex-start;\n\n}\n\n.MuiTypography-root.cameraControlTitle {\n    padding: 20px 20px 0px 20px;\n}\n\n.MuiButtonBase-root.cameraControlButton {\n    padding: 0px;\n}\n\n.MuiButtonBase-root.cameraControlButton .MuiSvgIcon-root {\n    width: 20px;\n    height: 20px;\n}\n\n/* Base shared styles */\n.MuiBox-root.cameraControlBox,\n.MuiBox-root.cameraControlBoxRight {\n    background-color: #343434;\n    border: 0.5px solid #50435C;\n    padding: 0px 4px;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.MuiBox-root.cameraControlBox {\n    text-align: left;\n}\n\n.MuiBox-root.cameraControlBoxRight {\n    text-align: right;\n}\n\n/* Hover effect shared */\n.MuiBox-root.cameraControlBox:hover,\n.MuiBox-root.cameraControlBoxRight:hover {\n    border: 1px solid #8D49cE;\n    background-color: #4B4B4B;\n}\n\n\n.MuiBox-root.cameraControlBoxNosubTitle {\n    background-color: #3b3c56;\n    border: 0.5px solid #50435C;\n    padding: 10px 20px;\n    border-radius: 10px;\n    margin-top: 10px;\n    display: flex;\n    gap: 20px;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n}\n\n.MuiCardContent-root.cameraControlContent {\n    margin-top: 10px;\n}\n\n.MuiTypography-root.buttontitle {\n    color: #E4E5ED;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 12px;\n}\n\n.MuiTypography-root.finalText {\n    color: #E4E5ED;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 12px;\n    padding: 0px 20px;\n}\n\n.MuiGrid-root.cameraControlGrid {\n    cursor: pointer;\n    align-items: center;\n}\n\n/* WithoutContent Text */\n.MuiPaper-root.videoPlaceholderCard {\n    height: 316px;\n}\n\n.MuiBox-root.videoPlaceholderContent {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n}\n\n.MuiTypography-root.videoPlaceholderText {\n    text-align: center;\n    color: #C2C2C2;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n/* scroll global style */\n.cameraControlContainer::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 10px;\n    background-clip: content-box;\n    padding: 20px 0;\n}\n\n.cameraControlContainer::-webkit-scrollbar-thumb {\n    background: #515261;\n    border-radius: 10px;\n    min-height: 10px;\n}\n\n.cameraControlContainer::-webkit-scrollbar {\n    width: 4px;\n}\n\n/* visiblityIcon */\n.MuiBox-root.visibilityIconContainer {\n    position: absolute;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(55, 54, 54, 0.25);\n    height: 90%;\n    border-radius: 10px;\n}\n\n.visibilityIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.MuiBox-root.cameraControlImageOverlay {\n    position: absolute;\n    right: 5%;\n    top: 15%;\n    bottom: 0;\n}\n\n.cameraImage {\n    width: 20px;\n    object-fit: cover;\n}\n\n.MuiTypography-root.mainDialogTitle {\n    background-color: #2D3055;\n    width: 98%;\n    border-radius: 10px;\n}\n\n.MuiTypography-root.videoLoadingText {\n    color: #fff;\n    font-family: var(--font-family-primary);\n    font-weight: 600;\n    font-size: 16px;\n    text-transform: capitalize;\n}\n\n.MuiBox-root.upload-studio-container {\n    cursor: pointer;\n    margin-top: 1rem;\n}\n\n.upload-existing-studio {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n    overflow-y: auto;\n    height: 130px;\n    justify-content: center;\n}\n\n.upload-existing-studio::-webkit-scrollbar {\n    width: 4px;\n}\n\n.upload-existing-studio::-webkit-scrollbar-thumb {\n    background-color: #ECEDF8;\n    border-radius: 10px;\n}\n\n@media screen and (min-width: 768px) {\n    .upload-existing-studio {\n        justify-content: flex-start;\n        gap: 5px;\n    }\n}\n\n@media screen and (min-width: 1023px) {\n    .upload-existing-studio {\n        justify-content: flex-start;\n        gap: 10px;\n    }\n}\n\n/* media queries */\n@media screen and (min-width: 768px) {\n    .MuiGrid-root.uploadImageContainer {\n        padding: 0px 20px;\n    }\n\n    .MuiGrid-root.mainContainerStudio {\n        padding: 0px 20px;\n        justify-content: flex-start;\n        align-items: flex-start;\n    }\n}\n\n/* ModalPopup css */\n.MuiDialog-root.modalMainContainer .MuiDialog-container {\n    background: rgba(26, 24, 27, 0.8);\n    align-items: flex-start;\n}\n\n.MuiDialog-root.modalMainContainer .MuiDialog-container .MuiPaper-root {\n    position: relative;\n    border-radius: 20px;\n    z-index: 1;\n    background: transparent;\n    box-shadow: 0px 4px 10px rgba(192, 191, 193, 0.25);\n    overflow: hidden;\n    position: relative;\n    top: 0%;\n}\n\n.MuiDialog-root.modalMainContainer .MuiDialog-container .MuiPaper-root::before {\n    content: '';\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    right: -1px;\n    bottom: -1px;\n    background-color: #2D3055;\n    z-index: -1;\n    border-radius: 20px;\n}\n\n.MuiDialog-root.modalMainContainerImage .MuiDialog-container {\n    background: rgba(26, 24, 27, 0.8);\n    align-items: center;\n}\n\n.MuiDialog-root.modalMainContainerImage .MuiDialog-container .MuiPaper-root {\n    position: relative;\n    border-radius: 20px;\n    z-index: 1;\n    background: transparent;\n    box-shadow: 0px 4px 10px rgba(192, 191, 193, 0.25);\n    overflow: hidden;\n    position: relative;\n    top: 0%;\n}\n\n.MuiDialog-root.modalMainContainerImage .MuiDialog-container .MuiPaper-root::before {\n    content: '';\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    right: -1px;\n    bottom: -1px;\n    background-color: #2D3055;\n    z-index: -1;\n    border-radius: 20px;\n}\n\n.MuiTypography-root.modalTitle {\n    background-color: #2D3055;\n    color: #fff;\n}\n\n.MuiBox-root.modalTitleBox {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px 20px;\n}\n\n.MuiTypography-root.modalTitleText {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 20px;\n    font-family: var(--font-family-primary);\n    font-weight: 600;\n    text-transform: capitalize;\n    color: #E4E5ED;\n}\n\n.cameracontrolIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.MuiDialogContent-root.modelContent {\n    background-color: #2D3055;\n    color: #fff;\n    padding: 24px;\n    overflow: hidden;\n}\n\n.videoImage {\n    width: 100%;\n    /* border-radius: 8px; */\n}\n\n.videoDataImage {\n    width: 500px;\n    height: 320px;\n    object-fit: contain;\n}\n\n.MuiButtonBase-root.checkBoxImage {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    color: white;\n}\n\n.videoContainer {\n    position: relative;\n}\n\n.MuiDialogActions-root.modalActions {\n    display: flex;\n    justify-content: center;\n    background-color: #2D3055;\n    padding: 0px 0px 40px 0px;\n    justify-content: center;\n}\n\n.MuiButtonBase-root.modalButton {\n    background-color: #6A1B9A;\n    color: #FDFCFF;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px;\n    text-transform: capitalize;\n    width: 250px;\n    border-radius: 7px;\n    padding: 12px 0px;\n}\n\n.MuiGrid-root.modalGridContainer {\n    justify-content: center;\n    padding-bottom: 0px !important;\n}\n\n.MuiDialog-root.modalContainer .MuiDialog-container {\n    background: rgba(26, 24, 27, 0.8);\n}\n\n.MuiDialog-root.modalContainer .MuiDialog-container .MuiPaper-root {\n    --Paper-shadow: none !important;\n}\n\n.MuiTypography-root.closeIconContainer {\n    display: flex;\n    justify-content: end;\n    position: absolute;\n    right: 0;\n}\n\n.MuiButtonBase-root.closeIconbutton {\n    position: absolute;\n    top: -7px;\n    right: 0;\n    color: white;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n}\n\n.MuiButtonBase-root.closeIconbutton .MuiSvgIcon-root {\n    width: 2rem;\n    height: 2rem;\n}\n\n.MuiBox-root.gheerButton {\n    position: absolute;\n    top: 10%;\n    right: 8px;\n    translate: translateY(-50%);\n    z-index: 2;\n}\n\n.gheerImage {\n    width: 30px;\n    height: 30px;\n}\n\n.MuiTypography-root.text-bracket {\n    color: rgba(141, 73, 206, 1);\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 16px;\n    display: inline;\n}\n\n.MuiTypography-root.text-normal {\n    color: rgba(255, 255, 255, 1);\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 16px;\n    display: inline;\n}\n\n/* .MuiTypography-root.previewTexts{\n    height: 10rem;\n    overflow-y: auto;\n    padding: 10px 10px;\n  \n} */\n.previewTextContainer {\n    border: 1px solid rgba(252, 250, 255, 0.5);\n    padding: 10px 10px;\n    border-radius: 10px;\n}\n\n.modalVideo {\n    width: 98%;\n    height: 50%;\n    /* object-fit: cover; */\n    aspect-ratio: calc(1/1);\n    border-radius: 10px;\n}\n\n.MuiBox-root.videoUploadCard {\n    height: 320px;\n    position: relative;\n}\n.MuiBox-root.videoUploadCardReels {\n    height: 320px;\n    position: relative;\n}\n\n.videoLoadingContainer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n}\n\n.gheerIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.MuiBox-root.videoDataImageContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.MuiBox-root.videoPromptContainer {\n    padding: 0px 20px;\n}\n\n\n/* Studio Home */\n.MuiGrid-root.studio-home-card {\n    padding: 0px 40px 40px 40px;\n    overflow-y: auto;\n    height: 80vh;\n    background: linear-gradient(to bottom, #2E335A, #1C1B33)\n}\n\n\n.MuiBox-root.card-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n}\n\n.MuiBox-root.studio-home-header {\n    padding: 20px 25px;\n    margin-bottom: 1rem;\n}\n\n/* coming soon page */\n.MuiBox-root.coming-soon-container {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100vh;\n    z-index: 1;\n    overflow: hidden;\n}\n\n.MuiBox-root.coming-soon-container::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-image: url('/public/assets/ComingSoon.webp');\n    background-repeat: no-repeat;\n    background-size: cover;\n    opacity: 0.1;\n    z-index: -1;\n}\n\n.MuiTypography-root.coming-soon-title {\n    font-family: var(--font-family-primary);\n    font-weight: 700;\n    color: #E4E5ED;\n    font-size: 32px;\n    text-transform: capitalize;\n    margin-top: 20px;\n}\n\n.MuiTypography-root.coming-soon-description {\n    font-family: var(--font-family-primary);\n    font-weight: 600;\n    color: #E4E5ED;\n    font-size: 16px;\n    text-transform: capitalize;\n    margin-top: 0;\n}\n\n.MuiBox-root.coming-soon-button-container {\n    margin-top: 20px;\n}\n\n.MuiCardContent-root.card-content {\n    background: linear-gradient(to bottom, rgba(72, 49, 157, 0.2) 20%, rgba(72, 49, 157, 0) 100%);\n    border-radius: 0px 0px 10px 10px;\n}\n\n.MuiBox-root.main-studio {\n    background: linear-gradient(to bottom, #2E335A, #1C1B33);\n    padding: 0px;\n}\n\n.MuiTypography-root.studio-home-title {\n    font-family: var(--font-family-primary);\n    font-weight: 600;\n    color: #E4E5ED;\n    font-size: 20px;\n    text-transform: capitalize;\n}\n\n.MuiTypography-root.card-description {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #E4E5ED;\n    font-size: 16px;\n    text-transform: capitalize;\n    margin-top: 0;\n    min-height: 40px;\n}\n\n.MuiTypography-root.studio-home-description {\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    color: #E4E5ED;\n    font-size: 16px;\n    text-transform: capitalize;\n    margin-top: 0;\n    line-height: 1.5;\n    margin-bottom: 1rem;\n}\n\n.MuiChip-root.coming-soon-chip {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background-color: #CADCFC;\n}\n\n.MuiChip-root.coming-soon-chip .MuiChip-label {\n    color: #000 !important;\n    font-family: var(--font-family-primary);\n    font-weight: 500;\n    font-size: 12px;\n}\n\n.coming-soon-banner {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    left: 0px;\n    width: 125px;\n    z-index: 10;\n    pointer-events: none;\n}\n\n.MuiBox-root.previewImageBox {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n\n@media screen and (min-width: 768px) {\n    .modalVideo {\n        aspect-ratio: calc(21/9);\n    }\n\n    .MuiDialog-root.modalMainContainer .MuiDialog-container .MuiPaper-root {\n        top: 15%;\n    }\n\n    .MuiBox-root.previewImageBox {\n        flex-direction: row;\n    }\n\n    .MuiGrid-root.studio-home-card {\n        height: 80vh;\n    }\n\n}\n\n@media screen and (min-width: 1023px) {\n    .MuiGrid-root.studio-home-card {\n        height: 90vh;\n    }\n   \n\n}\n\n\n@media screen and (min-width: 1440px) {\n    .MuiGrid-root.mainContainerStudio {\n        align-items: flex-start;\n        padding: 0px 20px;\n        justify-content: center;\n    }\n\n    .modalVideo {\n        aspect-ratio: calc(21/9);\n    }\n\n    .MuiBox-root.cameraControlContainer {\n        overflow-y: auto;\n        height: 100%;\n    }\n\n}\n\n@media screen and (min-width: 1441px) {\n    .MuiBox-root.cameraControlBox {\n        padding: 0px 15px;\n\n    }\n}\n\n@media screen and (min-width: 1920px) {\n    .modalVideo {\n        aspect-ratio: calc(16/9);\n    }\n\n    .waterMarkIcon {\n        width: 150px;\n    }\n\n\n}\n\n/* PodCast css */\n.MuiGrid-root.podcastMainContainer {\n    padding: 10px 40px;\n    position: relative;\n    height: calc(100vh - 169px);\n    overflow-y: auto;\n}\n\n.MuiGrid-root.podcastCardleft {\n    width: 100%;\n    background-color: #292B49;\n    display: block;\n    padding: 20px;\n    position: relative;\n}\n\n.MuiBox-root.uploadImageContainer {\n    width: 100%;\n    position: relative;\n    height: 100%;\n    padding: 20px 10px 20px 20px;\n}\n\n.MuiBox-root.inputContainer {\n    border: 2px dashed #aaa;\n    border-radius: 8px;\n    height: 173px;\n    width: 100%;\n}\n\n.MuiBox-root.uploadImageText {\n    position: absolute;\n    top: 19%;\n    /* left: 0; */\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    width: 100%;\n}\n\n.uploadedImageContainer {\n    text-align: center;\n    position: relative;\n}\n\n.removeImageContainer {\n    position: absolute;\n    top: 30.5%;\n    left: 37%;\n}\n\n.removeImageContainer .MuiSvgIcon-root {\n    color: red;\n}\n\n.uploadedImage {\n    width: 100%;\n    height: 167px;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n.MuiTypography-root.uploadText {\n    color: #EEEEF2;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 14px;\n    text-transform: none;\n    text-align: center;\n}\n\n.MuiBox-root.promptHeader {\n    display: flex;\n    justify-content: space-between;\n    margin: 0px 0px 17px 0px;\n    align-items: center;\n    align-items: center;\n}\n\n.promptHeaderText {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.MuiBox-root.videoCardThumbnail {\n    margin: 10px 0px;\n}\n\n.MuiBox-root.videoThumbnailCard {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    margin-top: 10px;\n    overflow-y: auto;\n\n}\n\n.MuiBox-root.videoThumbnailContainer {\n    display: flex;\n    align-items: center;\n    gap: 0px;\n    flex-wrap: wrap;\n    width: 100%;\n    min-height: 250px;\n}\n\n.videoThumbnail {\n    width: 131px;\n    height: 100px;\n    object-fit: contain;\n    border-radius: 8px;\n    position: relative;\n}\n\n.MuiGrid-root.podcastCardRight {\n    padding: 20px;\n    padding-top: 0px !important;\n}\n\n.MuiBox-root.voiceInputContainer {\n    display: flex;\n    align-items: center;\n    border: 1px solid #aaa;\n    border-radius: 8px;\n    padding: 4px 8px;\n    background: #23244a;\n}\n\n.MuiFormControl-root.voiceOptionContainer {\n    width: 100%;\n}\n\n.MuiFormControl-root.voiceOptionContainer .MuiFormGroup-root {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.MuiButtonBase-root.uploadButton {\n    background-color: transparent;\n    border: 1px solid #b3b0c1;\n    color: #fff !important;\n    text-transform: capitalize;\n    cursor: pointer;\n}\n\n.MuiButtonBase-root.uploadButton.Mui-disabled {\n    border: 1px solid #b3b0c1;\n    cursor: not-allowed;\n    pointer-events: visible;\n}\n\n.MuiInputBase-root.selectVoice {\n    border: 1px solid #b3b0c1;\n    width: 100%;\n    height: 65px;\n}\n\n.MuiInputBase-root .MuiSvgIcon-root {\n    color: #b3b0c1;\n}\n\n.selectVoice .MuiSelect-select {\n    display: flex;\n}\n\n.MuiSelect-outlined {\n    border-radius: 8px;\n    border: 1px solid #b3b0c1;\n}\n\n.MuiInputBase-root.selectVoice .MuiSvgIcon-root {\n    color: #b3b0c1;\n}\n\n.MuiFormControl-root.textField .Mui-disabled {\n    cursor: not-allowed;\n}\n\n.videoImage {\n    width: 100%;\n    /* height: 350px; */\n    object-fit: contain;\n    opacity: 0.8;\n}\n\n.MuiBox-root.inputView {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    margin-top: 20px;\n    width: 100%;\n}\n.MuiBox-root.aspectRatio{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n    margin: 20px 0px 10px 0px;\n}\n\n.MuiBox-root.width50 {\n    width: 100%;\n}\n\n.MuiAvatar-root.avatarSelector {\n    border: 2px solid #7F81A8;\n    background-color: transparent;\n}\n\n.avatarImages {\n    width: 30px;\n    height: 30px;\n    object-fit: contain;\n\n}\n\n.flagImages {\n    width: 20px;\n    height: 15px;\n    object-fit: cover;\n    border-radius: 4px;\n}\n\n.MuiBox-root.voiceOption {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    justify-content: space-between;\n}\n\n.MuiInputBase-root.MuiSelect-select {\n    display: flex;\n    align-items: center;\n}\n\n.chipLabel .MuiChip-label {\n    color: #fff !important;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 12px;\n}\n\n.MuiBox-root.GenerateButtonContainer {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    margin: 20px 0px 10px 0px;\n}\n\n.MuiSvgIcon-root.graphicIcon {\n    width: 15px;\n    height: 15px;\n}\n\n.MuiListSubheader-root.searchHeader {\n    background-color: #1F2138;\n    margin-bottom: 20px;\n    padding: 0px;\n    \n}\n\n.searchInput .MuiInputBase-input {\n    background-color: #1F2138;\n\n}\n\n.MuiBox-root.searchBox {\n    display: flex;\n    align-items: center;\n    padding: 4px 8px;\n    border: 0.5px solid #FFFFFF66;\n    border-radius: 8px;\n}\n\n.MuiBox-root.voiceList {\n    overflow-y: auto;\n    height: 200px;\n}\n\n.MuiBox-root.menuSelected {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    gap: 10px;\n    align-items: center;\n    \n}\n\n\n.MuiBox-root.podcastButtonContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.GenerateButtonContainer .MuiButtonBase-root {\n    /* width: 100%; */\n    height: 47px;\n}\n\n.MuiBox-root.width25 {\n    width: 100%;\n}\n\n.MuiBox-root.width75 {\n    width: 100%;\n}\n\n.MuiChip-root.hedraStyle {\n    background-color: #494B6B;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.hedraStyle .MuiChip-label {\n    color: #B1B3D6 !important;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    font-size: 13px;\n}\n\n.MuiBox-root.headerBox {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 10px;\n}\n\n.flagBox {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    cursor: pointer;\n}\n.MuiSlider-thumb{\n    background-color: #692AA5 !important;\n}\n.aspectRatio .MuiSelect-select{\n    padding: 12.5px 14px;\n}\n.podcastUpload-Container{\n    min-height: 250px;\n}\n@media screen and (min-width: 768px) {\n .MuiBox-root.videoThumbnailContainer{\n    gap: 5px;\n    justify-content: flex-start;\n }\n .MuiBox-root.promptHeader {\n    display: flex;\n    justify-content: space-between;\n    margin: 10px 0px 5px 0px;\n    align-items: center;\n    gap: 0px;\n    flex-direction: row;\n}\n .videoThumbnail {\n        width: 154px;\n    }\n    \n}\n\n@media screen and (min-width: 1024px) {\n    .MuiBox-root.inputView {\n        flex-direction: row;\n        align-items: center;\n    }\n    .MuiBox-root.aspectRatio{\n        flex-direction: row;\n        align-items: center;\n    }\n\n    .MuiBox-root.width50 {\n        width: 50%;\n    }\n\n    .MuiBox-root.width25 {\n        width: 25%;\n    }\n\n    .MuiBox-root.width75 {\n        width: 75%;\n    }\n\n    .MuiBox-root.uploadImageText {\n        width: 50%;\n    }\n\n    .MuiBox-root.podcastwidth {\n        width: 33.33335%;\n    }\n\n    .MuiBox-root.podcastVoiceContainer {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n        margin-top: 20px;\n        width: 100%;\n    }\n\n    .podcastButtonContainer {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n    }\n\n    .MuiGrid-root.podcastMainContainer {\n        height: calc(100vh - 135px);\n    }\n\n    .videoThumbnail {\n        width: 200px;\n    }\n\n    .MuiBox-root.uploadPromptHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .videoWrapper {\n        padding-top: 36.25%\n    }\n    .videoWrapperReels{\n        padding-top: 63.25%;\n    }\n \n.cinemotion-upload>.MuiBox-root>.my-masonry-grids{\n    height: calc(100dvh - 44rem);\n    overflow-y: auto;\n    min-height: 380px;\n}\n.cinemotion-upload>.MuiBox-root>.uploaded-images-grid{\n    height: calc(100dvh - 44rem);\n    overflow-y: auto;\n    min-height: 380px;\n\n}\n.podcastUpload-Container>.MuiBox-root>.my-masonry-grids{\n    height: calc(100dvh - 44rem);\n    overflow-y: auto;\n    min-height: 250px;\n}\n.podcastUpload-Container>.MuiBox-root>.uploaded-images-grid{\n    height: calc(100dvh - 44rem);\n    overflow-y: auto;\n    min-height: 250px;\n\n}\n\n}\n@media screen and (min-width: 1440px) {\n.cinemotion-upload>.MuiBox-root>.my-masonry-grids{\n    min-height: 410px;\n}\n.cinemotion-upload>.MuiBox-root>.uploaded-images-grid{\n    min-height: 410px;\n\n}\n}\n@media screen and (min-width: 1920px) {\n.cinemotion-upload>.MuiBox-root>.my-masonry-grids{\n    min-height: 520px;\n}\n.cinemotion-upload>.MuiBox-root>.uploaded-images-grid{\n    min-height: 520px;\n\n}\n}\n\n@media screen and (max-width: 460px) {\n.MuiGrid-root.podcastMainContainer {\n    padding: 2px;\n}\n.MuiBox-root.videoThumbnails {\n    height:100%;\n}\n/* Camera controls */\n.MuiPaper-root.cameraControlCard {\n height: 100%;\n}\n.videoThumbnail {\n    width: 118px;\n}\n.uploadContainer {\n    height:100%;\n}\n.MuiGrid-root.uploadImageContainer {\npadding-bottom: 20px;\n}\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
